import { Popper, ClickAwayListener, Fade, Paper, Box, Button, createTheme, Typography, ThemeProvider } from "@mui/material";
import React, { useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textarea } from "@mui/joy";
import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import CustomCurrencyTextField from "../../components/CustomCurrencyTextField";
import CustomTextField from "../../components/CustomTextField";
import DateSelector from "../../components/DateSelector";
import HistoryTable from "../../components/HistoryTable";
import MultiSelectPrimary from "../../components/MultiSelectPrimary";
import SelectBox from "../../components/SelectBox";
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { useDispatch, useSelector } from "react-redux";
import { setIsUpdatedStaff, setSelectedStaff } from "../../redux/reducers/dataCaptures";
import { useTranslation } from "react-i18next";
import EmploymentStatusSelect from "../../components/EmploymentStatusSelect";
import { formatDate, isEmpty } from "../../common/StaticExports";
import DepartmentAutocomplete from "../../components/DepartmentAutocomplete";
import RegisteredPositionAutoComplete from "../../components/RegisteredPositionAutoComplete";
import LeaderShipRolesAutocomplete from "../../components/LeaderShipRolesAutocomplete";
import QualificationsAutoComplete from "../../components/QualificationsAutoComplete";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '7%'
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: 13
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    marginTop: 0
                }
            }
        }
    }
})
const competitionHead = [
    {
      key: '', displayName: 'Club Name',
    },
    {
        key: '', displayName: 'From year',
    },
    {
        key: '', displayName: 'To year',
    },
    {
        key: '', displayName: '',
    },
  ]

const coachingHead = [
{
    key: '', displayName: 'Club Name',
},
{
    key: '', displayName: 'From year',
},
{
    key: '', displayName: 'To year',
},
{
    key: '', displayName: '',
},
]

const StaffDetailPage = (props:any) => {
    const { isOpen, handleClose } = props;
    const [addCompetionCareer, setAddCompetitionCareer] = useState(false);
    const [addCoachingCareer, setAddCoachingCareer] = useState(false);
    const selectedStaff = useSelector((state:any) => state.dataCaptures.selectedStaff);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const dispatch = useDispatch();
    const [t] = useTranslation();

    const updateState = ((key:any, updatedData:any) => {
        const updatedStaff = {
            ...selectedStaff,
            [key]: updatedData,
        };
        dispatch(setSelectedStaff(updatedStaff));
        const boolean:any = true;
        dispatch(setIsUpdatedStaff(boolean));
    });

    return (
            <React.Fragment>
                <ThemeProvider theme={theme}>
                <Popper className='popperStyle' open={isOpen} transition>
                        {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose}>
                    <Fade {...TransitionProps} timeout={350}>
                                <Paper sx={{ p: 2, width: '1200px', mt: '20px', height: '650px', overflowY: 'auto' }}>
                                    <Box className='mb20'>
                                        {/* <Typography className='standardsHeading uppercase'>Staff Details</Typography> */}
                                        <Box className={'addStaffForm'}>
                                            <CustomTextField label={t('DC_5_KENJI_NAME')} value={selectedStaff?.kanjiName} manageChange={(d:any) => updateState('kanjiName', d)} errorMessage={t('REQUIRED')} isError={isEmpty(selectedStaff?.kanjiName)} isDisabled={isAdmin} />
                                            <CustomTextField label={t('DC_5_KATAKANA_NAME')} value={selectedStaff?.katakanaName} manageChange={(d:any) => updateState('katakanaName', d)} errorMessage={t('REQUIRED')} isError={isEmpty(selectedStaff?.katakanaName)} isDisabled={isAdmin} />
                                            <CustomTextField label={t('DC_5_ENGLISH_NAME')} value={selectedStaff?.englishName} manageChange={(d:any) => updateState('englishName', d)} isDisabled={isAdmin} />
                                            <DateSelector label={t('DC_5_DOB')} dateValue={selectedStaff?.dateOfBirth} manageChange={(d:any) => {updateState('dateOfBirth', formatDate(d))}} isError={isEmpty(selectedStaff?.dateOfBirth)} errorMessage={t('REQUIRED')}  disabled={isAdmin} />
                                            <CustomTextField label={t('DC_5_JFA_ID')} value={selectedStaff?.jfaId} manageChange={(d:any) => updateState('jfaId', d)} isDisabled={isAdmin} />
                                            <CustomTextField label={t('DC_5_IRN')} value={selectedStaff?.instructorRegistrationNumber} manageChange={(d:any) => updateState('instructorRegistrationNumber', d)} errorMessage={t('REQUIRED')} isError={isEmpty(selectedStaff?.instructorRegistrationNumber)} isDisabled={isAdmin} />
                                            <EmploymentStatusSelect value={selectedStaff?.employmentStatus} manageSelect={(d:any) => updateState('employmentStatus', d)} isReadOnly={isAdmin} />
                                            <DepartmentAutocomplete selectedValues={selectedStaff?.department && selectedStaff?.department?.length > 0 ? selectedStaff?.department : []} manageSelect={(d:any) => updateState('department', d)} isReadOnly={isAdmin} />
                                            <DateSelector label={t('DC_5_LICENCE_START_DATE')} dateValue={selectedStaff?.licenceStart} manageChange={(d:any) => {updateState('licenceStart', formatDate(d))}} disabled={isAdmin} />
                                            <DateSelector label={t('DC_5_LICENCE_EXPIRY_DATE')} dateValue={selectedStaff?.licenceEnd} manageChange={(d:any) => {updateState('licenceEnd', formatDate(d))}} disabled={isAdmin} />
                                            <RegisteredPositionAutoComplete selectedValues={selectedStaff?.registeredPosition ? selectedStaff?.registeredPosition : []} manageSelect={(d:any) => updateState('registeredPosition', d)} isReadOnly={isAdmin} />
                                            <CustomTextField label={t('DC_5_JOB_TITLE')} value={selectedStaff?.jobTitle} manageChange={(d:any) => updateState('jobTitle', d)} errorMessage={t('REQUIRED')} isError={isEmpty(selectedStaff?.jobTitle)} isDisabled={isAdmin} />
                                            <LeaderShipRolesAutocomplete selectedValues={selectedStaff?.leadershipRole ? selectedStaff?.leadershipRole : []} manageSelect={(d:any) => updateState('leadershipRole', d)} isReadOnly={isAdmin} />
                                            <CustomCurrencyTextField label={t('DC_5_ANNUAL_SALARY')} value={selectedStaff?.annualSalary} manageChange={(d:any) => updateState('annualSalary', d)} isReadOnly={isAdmin} />
                                            <QualificationsAutoComplete selectedValues={selectedStaff?.qualifications ? selectedStaff?.qualifications : []} manageSelect={(d:any) => updateState('qualifications', d)} isReadOnly={isAdmin} />
                                        </Box>
                                        <Box className='mb20'>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography className='standardsHeading uppercase'>Competition Career</Typography>
                                                {
                                                    !isAdmin &&
                                                    <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCompetionCareer} variant='contained' size='small' onClick={() => {setAddCompetitionCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                        {'Add another club'}
                                                    </Button>
                                                }
                                            </Box>
                                            <Box>
                                                <HistoryTable
                                                  data={selectedStaff?.competitionCareers}
                                                  head={competitionHead}
                                                  addData={addCompetionCareer}
                                                  updateList={(e:any) => {updateState('competitionCareers', e)}}
                                                  handleClick={() => setAddCompetitionCareer(false)}/>
                                            </Box>
                                        </Box>
                                        <Box className='mb20'>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography className='standardsHeading uppercase'>Coaching Career</Typography>
                                                {
                                                    !isAdmin &&
                                                    <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCoachingCareer} variant='contained' size='small' onClick={() => {setAddCoachingCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                        {'Add another organization'}
                                                    </Button>
                                                }
                                            </Box>
                                            <Box>
                                                <HistoryTable
                                                  data={selectedStaff?.coachingCareers}
                                                  head={coachingHead}
                                                  addData={addCoachingCareer}
                                                  updateList={(e:any) => {updateState('coachingCareers', e)}}
                                                  handleClick={() => setAddCoachingCareer(false)}/>
                                            </Box>
                                        </Box>
                                        <Box className='mb20'>
                                            <JoyCssVarsProvider>
                                                <FormControl className={isAdmin && 'cursorNotAllowed'} error={isEmpty(selectedStaff?.mainDuties)} disabled={isAdmin}>
                                                    <Textarea 
                                                    sx={{ borderRadius: '6px', mt: 0, width: '100%', 
                                                        // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                        '&.Mui-disabled': {
                                                            '--Textarea-disabledColor': 'black',
                                                            color: 'black',
                                                            cursor: 'not-allowed'
                                                        }, }} 
                                                    value={selectedStaff?.mainDuties}
                                                    onChange={(e:any) => {updateState('mainDuties', e.target.value)}} 
                                                    placeholder='Main duties are...' 
                                                    minRows={2} maxRows={2}
                                                    disabled={isAdmin}
                                                    />
                                                    {isEmpty(selectedStaff?.mainDuties) && (
                                                        <FormHelperText>{t('REQUIRED')}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </JoyCssVarsProvider>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Fade>
                        </ClickAwayListener>
                        )}
                    </Popper>
                </ThemeProvider>
            </React.Fragment>
    )
}

export default StaffDetailPage;